export type ChapterSortDirection = "asc" | "desc";

export interface VolumeChapterMetadata {
    id: string;
    sortOrder: number;
    volumeId: string;
    volumeTitle: string;
}

export interface VolumeChapterGroup<T extends VolumeChapterMetadata> {
    id: string;
    title: string;
    chapters: T[];
}

/**
 * Sort chapters as one global sequence, then collect the contiguous volume
 * sections produced by that sequence. Volumes are never sorted independently.
 */
export function groupChaptersByVolume<T extends VolumeChapterMetadata>(
    chapters: T[],
    direction: ChapterSortDirection,
): VolumeChapterGroup<T>[] {
    const multiplier = direction === "asc" ? 1 : -1;
    const ordered = [...chapters].sort(
        (left, right) => (left.sortOrder - right.sortOrder) * multiplier,
    );
    const groups: VolumeChapterGroup<T>[] = [];
    const groupsById = new Map<string, VolumeChapterGroup<T>>();

    for (const chapter of ordered) {
        let group = groupsById.get(chapter.volumeId);
        if (!group) {
            group = {
                id: chapter.volumeId,
                title: chapter.volumeTitle,
                chapters: [],
            };
            groupsById.set(chapter.volumeId, group);
            groups.push(group);
        }
        group.chapters.push(chapter);
    }

    return groups;
}
